import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class MaterialStorecheckingApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'materialStorechecking'
  }

}